import userService from '@/service/userService'
import axios from 'axios'
import MainPresenter from "@/service/MainPresenter"
import appConfig from '@/service/config'
import moment from 'moment'
import un from 'underscore'
import { escapeParam } from "@/service/UrlEncoder"

const mainPresenter = new MainPresenter();

const FORM_OPTIONS = {
    "Simlock": {
        NONE: "Brak",
        PLAY: "Play",
        PLUS: "Plus",
        T_MOBILE: "T-Mobile",
        ORANGE: "Orange",
        OTHER: "Inny"
    },
    "PhoneState": {
        NEW: "Nowy",
        USED: "Używany"
    },
    "PhoneOrigin": {
        PLAY: "Play",
        PLUS: "Plus",
        T_MOBILE: "T-Mobile",
        ORANGE: "Orange",
        MEDIA_MARKT: "Media Markt",
        MEDIA_EXPERT: "Media Expert",
        SATURN: "Saturn",
        NEONET: "Neonet",
        EURO_RTV: "Euro RTV",
        KOMIS: "Komis",
        WHOLESALER: "Hurtownia",
        IDREAM: "iDream",
        INTERNET: "Internet",
        X_KOM: "X-Kom",
        HOKO_LAB: "HokoLab",
        WIECHU: "Wiechu",
        OTHER: "Inne"
    }
}

const PhonesService = function() {

    function buildParamsSearch(requestData) {
        return {
            "brandName": requestData.params.brandName,
            "actualStoreId": requestData.params.actualStoreId,
            "phoneStatus": requestData.params.phoneStatus,
            "itemsPage": requestData.pageable.page,
            "itemsSize": 60
        }
    }

    this.search = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: mainPresenter.getUrlForParams("/phones/search", buildParamsSearch(requestData)),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.parseGuarantee = function(guarantee, guaranteeDateValue) {
        if (guarantee === "DateGuarantee") return moment(guaranteeDateValue).format("YYYY-MM-DD HH:mm:ss")
        if (guarantee === "NoGuarantee") return "NoGuarantee"
        return ""
    }

    function buildParamsAddPhone(requestData) {
        return {
            phoneNameId: requestData.phoneNameId,
            storeOfPurchaseId: requestData.storeOfPurchaseId,
            actualStoreId: requestData.actualStoreId,
            guarantee: requestData.guarantee,
            phoneOrigin: requestData.phoneOrigin,
            simLock: requestData.simLock,
            colorId: requestData.colorId,
            phoneState: requestData.phoneState,
            dateOfPurchase: moment(requestData.dateOfPurchase).format("YYYY-MM-DD HH:mm:ss"),
            paidAmount: requestData.paidAmount,
            suggestedPrice: requestData.suggestedPrice,
        }
    }

    this.addPhone = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/phones',
            data: buildParamsAddPhone(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.editAvailablePhone = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + `/phones/${requestData.id}/edit`,
            data: buildParamsAddPhone(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.soldPhone = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/phones/soldPhone',
            data: requestData,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.loadConfig = function(onSuccess) {
        const req = axios({
            method: 'get',
            url: appConfig.baseUrl + '/phones/config',
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            console.log(e)
        })
    }

    this.initOptions = function(options, defaultValue, optionType) {
        const finalList = []
        const defaultOption = {
            id: defaultValue,
            name: "wybierz opcję"
        }
        finalList.push(defaultOption)
        for (var i in options) {
            var item = options[i]
            finalList.push({
                id: item,
                name: FORM_OPTIONS[optionType][item]
            })
        }
        return finalList
    }

    this.isAdmin = function() {
        return userService.isAdmin()
    }

    this.initStores = function(onSuccess) {
        axios.get(mainPresenter.buildUrlWithDefaults("/allStores?visible=true")).then(response => {
            const currentStoreId = userService.getCurrentStore()
            const currentStore = un.find(response.data.content, function(item) {
                return item.id === currentStoreId
            })
            onSuccess(response.data.content, currentStore);
        }, err => {
            console.log(err)
        })
    }

    this.searchPhoneNames = function(term, handler) {
        var pageable = {
            "itemsPage": 0,
            "itemsSize": 40,
            "sort": "name,asc"
        }
        const req = axios({
          method: 'get',
          url: mainPresenter.getUrlForCommonData(
              "/phoneNames/search",
              { phoneName: escapeParam(term) },
              pageable),
          headers: {
            Authorization: userService.getAuthHeader()
          }
        })
        req.then(res => {
            handler(res.data)
        }).catch(e => {
            console.log(e)
        })
    }

    this.searchPhoneNamesMapper = function(data) {
        return un.map(data.phoneNames, item => {
            return {
                id: item.id,
                name: item.name
            }
        })
    }

    this.searchColors = function(term, handler) {
        var pageable = {
            "page": 0,
            "size": 40,
            "sort": "name,asc"
        }
        const req = axios({
          method: 'get',
          url: mainPresenter.getUrlForCommonData(
              "/colors/search/findByNameContainsIgnoreCase",
              { name: escapeParam(term) },
              pageable),
          headers: {
            Authorization: userService.getAuthHeader()
          }
        })
        req.then(res => {
            handler(res.data)
        }).catch(e => {
            console.log(e)
        })
    }

    this.searchColorsMapper = function(data) {
        return un.map(data._embedded.colors, item => {
            return {
                id: item.id,
                name: item.name
            }
        })
    }

    this.findPhone = function(uuid, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: `${appConfig.baseUrl}/phones/${uuid}`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        })
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.deletePhone = function(id, onSuccess, onError) {
        const req = axios({
            method: 'delete',
            url: `${appConfig.baseUrl}/phones/${id}`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    return {
        "findPhone": this.findPhone,
        "search": this.search,
        "addPhone": this.addPhone,
        "loadConfig": this.loadConfig,
        "parseGuarantee": this.parseGuarantee,
        "initOptions": this.initOptions,
        "initStores": this.initStores,
        "isAdmin": this.isAdmin,
        "searchPhoneNames": this.searchPhoneNames,
        "searchPhoneNamesMapper": this.searchPhoneNamesMapper,
        "searchColors": this.searchColors,
        "searchColorsMapper": this.searchColorsMapper,
        "editAvailablePhone": this.editAvailablePhone,
        "soldPhone": this.soldPhone,
        "deletePhone": this.deletePhone
    }
}

export default PhonesService;



// WEBPACK FOOTER //
// ./src/components/phones/PhonesService.js